/*
 * Public API Surface of material
 */

export * from './lib/material.module';
export * from './lib/components';
export { COMPONENTS_LIST, getCategories } from './lib/components/register';
